import { Box, Button, Flex, HStack, SimpleGrid, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import axiosInstance from "../../../config/axiosInstance";
import CustomDateRangePicker from "../CustomDateRangePicker";

const Stats = ({ fromDate, toDate, setFromDate, setToDate,url }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [stats, setStats] = useState({});
  const [activeRange, setActiveRange] = useState("Today");

  // fetch stats using current fromDate, toDate
  const fetchStats = async () => {
    try {
      const res = await axiosInstance.get("/api/orders/stats/receptionist", {
        params: { fromDate, toDate },
      });
      setStats(res?.data);
    } catch (error) {
      console.error("Error fetching stats:", error.message);
    }
  };

  // fetch stats whenever date changes
  useEffect(() => {
    if (fromDate && toDate) fetchStats();
    // eslint-disable-next-line
  }, [fromDate, toDate]);

  const handleDateRangeClick = (range) => {
    setActiveRange(range);
    setShowDatePicker(range === "Custom");

    const today = dayjs();
    if (range === "Today") {
      setFromDate(today.format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    } else if (range === "Last7") {
      setFromDate(today.subtract(6, "day").format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    } else if (range === "Last30") {
      setFromDate(today.subtract(29, "day").format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    }
  };

  const handleApplyDateRange = ({ fromDate, toDate }) => {
    setFromDate(fromDate);
    setToDate(toDate);
  };

  return (
    <>
      <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={3}>
        <Box>
          <Text fontSize="2xl" fontWeight="bold">
            Order History
          </Text>
          <Text fontSize="sm" color="gray.600">
            {fromDate} → {toDate}
          </Text>
        </Box>

        <HStack spacing={2} flexWrap="wrap">
          {["Today", "Last7", "Last30", "Custom"].map((label) => (
            <Button
              key={label}
              size="sm"
              variant={activeRange === label ? "solid" : "outline"}
              colorScheme={label === "Custom" ? "orange" : "gray"}
              onClick={() => handleDateRangeClick(label)}
            >
              {label === "Last7"
                ? "Last 7 Days"
                : label === "Last30"
                ? "Last 30 Days"
                : label === "Custom"
                ? "Custom Date"
                : "Today"}
            </Button>
          ))}
        </HStack>
      </Flex>

      <SimpleGrid columns={[2, 2, 4]} spacing={4} mb={6}>
        {[
          { label: "Total Orders", value: stats?.totalOrders || 0 },
          { label: "Total Delivered", value: stats?.totalDelivered || 0 },
          { label: "Total Pending", value: stats?.totalPending || 0 },
          { label: "Total Assigned", value: stats?.totalAssigned || 0 },
        ].map((card, idx) => (
          <Box key={idx} bg="white" borderRadius="md" p={4} shadow="sm">
            <Text fontWeight="bold">{card.label}</Text>
            <Text fontSize="2xl">{card.value}</Text>
          </Box>
        ))}
      </SimpleGrid>

      {showDatePicker && (
        <Box mb={4}>
          <CustomDateRangePicker
            onApply={handleApplyDateRange}
          />
        </Box>
      )}
    </>
  );
};

export default Stats;
